// src/config/gauges/victex1comp.js

export const victex1CompGaugeConfig = [

  // 1) Temperatura Proceso Entrada
  {
    key: "tempProcesoEntrada",
    title: "Temp. Proceso Entrada",
    unit: "°C",
    ranges: [
      { min: 8,   max: 14.99, color: "green" },
      { min: 5,   max: 7.99,  color: "yellow" }, // (5,8)
      { min: 15,  max: 19.99, color: "yellow" }, // (15,20)
      { min: 0,   max: 4.99,  color: "red" },
      { min: 20, max: 50000, color: "red" },
    ],
  },

  // 2) Temperatura Proceso Salida
  {
    key: "tempProcesoSalida",
    title: "Temp. Proceso Salida",
    unit: "°C",
    ranges: [
      { min: 6.5, max: 13.99,  color: "green" },
      { min: 5,   max: 6.49, color: "yellow" }, // (5,6.5)
      { min: 14,  max: 19.99,  color: "yellow" }, // (14,20)
      { min: 0,   max: 4.99,   color: "red" },
      { min: 20,  max: 10000, color: "red" },
    ],
  },

  // 3) Temperatura Descarga C1
  {
    key: "tempDescarga",
    title: "Temp. Descarga C1",
    unit: "°C",
    ranges: [
      { min: 50, max: 69.99,  color: "green" },
      { min: 40, max: 49.99,  color: "yellow" },
      { min: 70, max: 90.99,  color: "yellow" },
      { min: 0,  max: 39.99,  color: "red" },
      { min: 91, max: 15000, color: "red" },
    ],
  },

    // 4) Temperatura Ambiente bien 
  {
    key: "tempAmbiente",
    title: "Temp. Ambiente",
    unit: "°C",
    ranges: [
      { min: 32, max: 39.99,  color: "green" },
      { min: 25, max: 31.99,  color: "yellow" }, // (25,32)
      { min: 40, max: 49.99,  color: "yellow" }, // (40,50)
      { min: 0,  max: 24.99,  color: "red" },
      { min: 50, max: 20000, color: "red" },
    ],
  },
  
  // 1) Presión de Succión C1
  {
    key: "presionSuccion",
    title: "Pres. Succión C1",
    unit: "psi",
    ranges: [
      { min: 29,  max: 32.99,  color: "green" },
      { min: 27,   max: 28.99,  color: "yellow" }, // (5,10)
      { min: 33,  max: 35.99,  color: "yellow" }, // (40,60)
      { min: 0, max: 26.99,   color: "red" },
      { min: 36,  max: 20000, color: "red" },
    ],
  },

  // 2) Presión de Descarga C1
  {
    key: "presionDescarga",
    title: "Pres. Descarga C1",
    unit: "psi",
    ranges: [
      { min: 160, max: 210.99, color: "green" },
      { min: 140, max: 159.99, color: "yellow" }, // (140,160)
      { min: 211, max: 220.99, color: "yellow" }, // (200,220)
      { min: 0,   max: 139.99, color: "red" },
      { min: 221, max: 25000, color: "red" },
    ],
  },

];
